import _reduxForm from "redux-form/es/reduxForm";
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { subscribeUserToOutOfStockProduct } from '../../../../../redux/product/product.actions';
import { TimeOverForLimitedEditionForm as TimeOverForLimitedEditionFormComponent } from './time-over-for-limited-edition-form';
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    browserHistory.push(APP_ROUTES.ALL_SWAG);
    dispatch(hidePopup());
  },
  onSubscribe: data => {
    dispatch(subscribeUserToOutOfStockProduct(data));
    dispatch(hidePopup());
  }
});
export const TimeOverForLimitedEditionForm = connect(null, mapDispatchToProps)(_reduxForm({
  form: 'timeOverForLimitedEditionForm',
  initialValues: {
    email: ''
  },
  destroyOnUnmount: true
})(TimeOverForLimitedEditionFormComponent));